import React from "react";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import { Home, Projects, Services, Contact, Team } from "./pages";

const Router = props => {
  return (
    <BrowserRouter>
      <>
        {props.children}
        <Switch>
          <Route path="/" exact component={Home} />
          <Route path="/team" component={Team} />
          <Route path="/contact" component={Contact} />
        </Switch>
      </>
    </BrowserRouter>
  );
};


export default Router;
